import { render } from "./PersonInfoComponent.vue?vue&type=template&id=d3ef338e&scoped=true"
import script from "./PersonInfoComponent.vue?vue&type=script&lang=js"
export * from "./PersonInfoComponent.vue?vue&type=script&lang=js"

import "./PersonInfoComponent.vue?vue&type=style&index=0&id=d3ef338e&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3ef338e"]])

export default __exports__